module.exports = __webpack_public_path__ + "f7a68f2cc93dce5059a052dfc9f286ae.pdf";